import React from 'react'

const iconWidth = {
    width: "20px",
    height: "20px"
}

const FooterSocialIcons = () => {
  return (
    <ul className="social-icons list-inline">
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://twitter.com/GetFridayVA" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/twitterX.png" alt="GetFriday on X"/></a></li>
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://www.facebook.com/GetFriday" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/face.png" alt="GetFriday on Facebook" /></a></li>
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://www.youtube.com/channel/UCyXzYt0GN5bDPcC-xx4DmKA" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/youtube.png" alt="GetFriday on YouTube" /></a></li>
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://www.linkedin.com/company/getfriday" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/linkedIn.png" alt="GetFriday on LinkedIn" /></a></li>
    </ul>
  )
}

export default FooterSocialIcons
